import { render, staticRenderFns } from "./McSupplyChainOcrView.vue?vue&type=template&id=ae3cc914&scoped=true&"
import script from "./McSupplyChainOcrView.vue?vue&type=script&lang=js&"
export * from "./McSupplyChainOcrView.vue?vue&type=script&lang=js&"
import style0 from "./McSupplyChainOcrView.vue?vue&type=style&index=0&id=ae3cc914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3cc914",
  null
  
)

export default component.exports